import React from 'react';
import { Link } from 'react-router-dom';

const faqs = [
  {
    q: 'How do I create an account?',
    a: 'Tap "Get started" on the home page or go to the Register page. You can sign up with an email and password, or continue with Google.',
  },
  {
    q: 'I forgot my password. What do I do?',
    a: 'Email us at the address below with your account email and we\'ll help you regain access.',
  },
  {
    q: 'Where can I download HiveFall?',
    a: 'Visit the Download page for links to the Android and iOS versions once they go live.',
  },
  {
    q: 'Is HiveFall available on PC or consoles?',
    a: 'HiveFall is currently in development for mobile. Additional platforms may be announced later — check back for updates.',
  },
  {
    q: 'I found a bug or the game crashed. How do I report it?',
    a: 'Email us with your device model, OS version, and a short description (screenshots or video help a lot) so we can reproduce and fix it quickly.',
  },
  {
    q: 'How do I delete my account and data?',
    a: 'Email us from your account\'s registered email address and request deletion. We\'ll confirm once your account and associated data have been removed.',
  },
];

export default function Support() {
  return (
    <div className="min-h-screen" style={{ background: 'var(--brand-bg)' }}>
      <div className="mx-auto max-w-3xl px-4 py-14 sm:px-6 lg:px-8">
        <span className="pill">Help</span>
        <h1 className="page-title section-gap">Support</h1>
        <p className="page-subtitle">
          Stuck in the Hive? Find answers below, or reach out and we'll get back to you as soon as we can.
        </p>

        <div className="mt-8 rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
          <p className="font-black text-slate-900">Contact us</p>
          <p className="mt-1 text-sm text-slate-500">
            For account issues, bug reports, or anything else, email{' '}
            <a href="mailto:support@playhivefall.com" className="font-bold text-[var(--brand-primary)] hover:underline">
              support@playhivefall.com
            </a>
            . We typically reply within 2–3 business days.
          </p>
        </div>

        <h2 className="mt-10 text-lg font-black text-slate-900">Frequently asked questions</h2>
        <div className="mt-4 space-y-3">
          {faqs.map((f) => (
            <details key={f.q} className="group rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
              <summary className="cursor-pointer list-none font-bold text-slate-900 marker:content-none">
                <span className="flex items-center justify-between gap-3">
                  {f.q}
                  <span className="shrink-0 text-slate-400 transition group-open:rotate-45">+</span>
                </span>
              </summary>
              <p className="mt-2 text-sm leading-relaxed text-slate-600">{f.a}</p>
            </details>
          ))}
        </div>

        <Link to="/" className="mt-10 inline-block text-sm font-bold text-[var(--brand-primary)] hover:underline">
          ← Back to home
        </Link>
      </div>
    </div>
  );
}
